import React, { useState, useEffect } from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import { IconCheck, IconX, IconClock, IconSend } from "@tabler/icons-react";
import { AUTOMATIONS_URL } from "../../api/Urls";
import { api } from "../../api/Middleware";

const AutomationStats = ({ automationId }) => {
  const [stats, setStats] = useState({
    total_messages: 0,
    sent_messages: 0,
    pending_messages: 0,
    failed_messages: 0,
    success_rate: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Exemplo de função para buscar estatísticas (a ser implementada)
    const fetchStats = async () => {
      setLoading(true);
      try {
        const response = await api.get(
          `${AUTOMATIONS_URL}${automationId}/stats/`
        );
        setStats(response.data);
      } catch (error) {
        console.error("Erro ao buscar estatísticas:", error);
        setLoading(false);
      }
    };

    fetchStats();
  }, [automationId]);

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">Desempenho da Automação</h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col xs={6} md={3} className="text-center mb-3">
            <div className="d-flex flex-column align-items-center">
              <div className="rounded-circle bg-primary bg-opacity-10 p-3 mb-2">
                <IconSend size={24} className="text-primary" />
              </div>
              <h2 className="h4 mb-0">{stats.total_messages}</h2>
              <span className="text-muted small">Total de Mensagens</span>
            </div>
          </Col>

          <Col xs={6} md={3} className="text-center mb-3">
            <div className="d-flex flex-column align-items-center">
              <div className="rounded-circle bg-success bg-opacity-10 p-3 mb-2">
                <IconCheck size={24} className="text-success" />
              </div>
              <h2 className="h4 mb-0">{stats.sent_messages}</h2>
              <span className="text-muted small">Enviadas</span>
            </div>
          </Col>

          <Col xs={6} md={3} className="text-center mb-3">
            <div className="d-flex flex-column align-items-center">
              <div className="rounded-circle bg-warning bg-opacity-10 p-3 mb-2">
                <IconClock size={24} className="text-warning" />
              </div>
              <h2 className="h4 mb-0">{stats.pending_messages}</h2>
              <span className="text-muted small">Pendentes</span>
            </div>
          </Col>

          <Col xs={6} md={3} className="text-center mb-3">
            <div className="d-flex flex-column align-items-center">
              <div className="rounded-circle bg-danger bg-opacity-10 p-3 mb-2">
                <IconX size={24} className="text-danger" />
              </div>
              <h2 className="h4 mb-0">{stats.failed_messages}</h2>
              <span className="text-muted small">Falhas</span>
            </div>
          </Col>
        </Row>

        <div className="text-center mt-2">
          <Badge
            bg={
              stats.success_rate > 90
                ? "success"
                : stats.success_rate > 75
                ? "warning"
                : "danger"
            }
            className="p-2"
          >
            Taxa de Sucesso: {stats.success_rate}%
          </Badge>
        </div>
      </Card.Body>
    </Card>
  );
};

export default AutomationStats;
